import { ComponentProps } from 'react';
import { Text, TextLink } from '@updater/ui-uds';

export type TermsAndPrivacyDisclaimerProps = ComponentProps<typeof Text> & {
  // Leading clause, e.g. `By continuing,` or `By clicking "Select,"` -
  // rendered directly before the fixed "you agree to the [link]." sentence.
  prefix?: string;
};

export function TermsAndPrivacyDisclaimer({
  prefix = 'By continuing,',
  ...textProps
}: TermsAndPrivacyDisclaimerProps) {
  const isIFramed = typeof window !== 'undefined' && window.self !== window.top;

  return (
    <Text variant="xs" {...textProps}>
      {prefix} you agree to the{' '}
      <TextLink
        data-testid="termsAndPrivacyLink"
        showTextDecoration
        href="https://updater.com/uhs-terms/"
        target={isIFramed ? '_blank' : undefined}
      >
        Terms of service and privacy policy
      </TextLink>
      .
    </Text>
  );
}
